import * as React from 'react';
import { styled } from '@mui/material/styles';
import { QuickFilter, QuickFilterControl, QuickFilterClear } from '@mui/x-data-grid-pro';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';

const StyledQuickFilter = styled(QuickFilter)({
  display: 'grid',
  alignItems: 'center',
  marginLeft: 0,
  border: 'none'
});

const StyledTextField = styled(TextField)(({ theme }) => ({
  gridArea: '1 / 1',
  overflowX: 'clip',
  width: 206,
  opacity: 1,
  transition: theme.transitions.create(['width', 'opacity']),
  border: 'none'
}));

export const CustomQuickFilter = () => {
  return (
    <StyledQuickFilter
      defaultExpanded
      data-testid="grid-toolbar-search"
      data-cy="data-grid-search">
      <QuickFilterControl
        render={({ ref, ...controlProps }, state) => (
          <StyledTextField
            {...controlProps}
            inputRef={ref}
            aria-label="Search"
            placeholder="Search..."
            size="small"
            slotProps={{
              input: {
                sx: {
                  padding: '0',
                  '.MuiInputBase-input': {
                    padding: '4px 0 5px'
                  }
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: state.value ? (
                  <InputAdornment position="end">
                    <QuickFilterClear
                      edge="end"
                      size="small"
                      aria-label="Clear search"
                      material={{ sx: { marginRight: -0.75 } }}>
                      <CancelIcon fontSize="small" />
                    </QuickFilterClear>
                  </InputAdornment>
                ) : null,
                ...controlProps.slotProps?.input
              },
              ...controlProps.slotProps
            }}
          />
        )}
      />
    </StyledQuickFilter>
  );
};
